"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _locality = require("./locality");
Object.keys(_locality).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _locality[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _locality[key];
    }
  });
});